<template>
  <div v-show="processing" class="checkout-processing" :style="getOpacity">
    <h2 style="font-weight: bold; padding-bottom: 1rem">Processing...</h2>
    <div>
      <i class="fa fa-refresh fa-5x spinner"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    processing: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getOpacity() {
      return this.processing ? { opacity: 1 } : { opacity: 0 };
    },
  },
};
</script>

<style scoped>
.checkout-processing {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 1150 !important;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(209, 108, 0);
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
}

.spinner {
  width: 70px;
  height: 70px;
  color: rgb(209, 108, 0);
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
}
</style>
